var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
export var CTAButton = styled.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  background-color: ", ";\n  border-radius: ", ";\n  padding: 9px 16px;\n  border: none;\n  transition: background-color ", " ease;\n  cursor: pointer;\n  &:hover {\n    background-color: ", ";\n  }\n  &:disabled {\n    background-color: ", ";\n    cursor: not-allowed;\n    color: ", ";\n    &:hover {\n      background-color: ", ";\n      color: ", ";\n    }\n  }\n  &.red {\n    background-color: ", ";\n    &:hover {\n      background-color: ", ";\n    }\n  }\n  &.smallish {\n    font-size: 1.4rem;\n    letter-spacing: 0.2px;\n    padding: 8px 12px;\n  }\n  &.extraPadding {\n    padding: 13px 22px;\n  }\n"], ["\n  color: ", ";\n  background-color: ", ";\n  border-radius: ", ";\n  padding: 9px 16px;\n  border: none;\n  transition: background-color ", " ease;\n  cursor: pointer;\n  &:hover {\n    background-color: ", ";\n  }\n  &:disabled {\n    background-color: ", ";\n    cursor: not-allowed;\n    color: ", ";\n    &:hover {\n      background-color: ", ";\n      color: ", ";\n    }\n  }\n  &.red {\n    background-color: ", ";\n    &:hover {\n      background-color: ", ";\n    }\n  }\n  &.smallish {\n    font-size: 1.4rem;\n    letter-spacing: 0.2px;\n    padding: 8px 12px;\n  }\n  &.extraPadding {\n    padding: 13px 22px;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.gwThemed.buttons.main.color;
}, function (_a) {
    var theme = _a.theme;
    return theme.gwThemed.buttons.main.bg;
}, function (_a) {
    var theme = _a.theme;
    return theme.borders.radius;
}, function (_a) {
    var theme = _a.theme;
    return theme.transitions.normal;
}, function (_a) {
    var theme = _a.theme;
    return theme.gwThemed.buttons.main.hoverBg;
}, function (_a) {
    var theme = _a.theme;
    return theme.gwThemed.buttons.disabled.bg;
}, function (_a) {
    var theme = _a.theme;
    return theme.gwThemed.buttons.disabled.color;
}, function (_a) {
    var theme = _a.theme;
    return theme.gwThemed.buttons.disabled.bg;
}, function (_a) {
    var theme = _a.theme;
    return theme.gwThemed.buttons.disabled.color;
}, function (_a) {
    var theme = _a.theme;
    return theme.gwThemed.buttons.danger.bg;
}, function (_a) {
    var theme = _a.theme;
    return theme.gwThemed.buttons.danger.hoverBg;
});
var templateObject_1;
//# sourceMappingURL=CTAButton.js.map